
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/research-studies/upskills-new-teachers",
      function () {
        return require("private-next-pages/research-studies/upskills-new-teachers.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/research-studies/upskills-new-teachers"])
      });
    }
  